import React from 'react';
import { ExerciseRow, ExerciseIcon } from './style';
import { Text } from '../../../UI/Text';
import { config } from '../../../../Configurations';

import { Icon } from '../../Icons/Icons';

export const Exercise = ({ isStatic, icon, name, onClick, workoutIcon, index }) => {
    const WorkoutIcon = workoutIcon;

    return (
        <ExerciseRow onClick={onClick}>
            {isStatic ? (
                <Icon.Box size={'26x26'}>
                    <WorkoutIcon />
                </Icon.Box>
            ) : (
                <ExerciseIcon img={`${config.baseUrl}/${icon}`} />
            )}

            <Text weight={300} fontSize={13}>
                {name}
            </Text>
        </ExerciseRow>
    );
};



// WEBPACK FOOTER //
// ./src/UI/Components/Rows/ExerciseRow/index.js